module.exports = __webpack_public_path__ + "img/footer_logo1.b0310cca.png";